// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-primary);
  position: relative;
  overflow: hidden;
}

.auth-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.auth-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.15;
  pointer-events: none;
}

.auth-blob-1 {
  width: 500px;
  height: 500px;
  background: var(--brand-primary);
  top: -100px;
  right: -100px;
}

.auth-blob-2 {
  width: 400px;
  height: 400px;
  background: var(--info);
  bottom: -100px;
  left: -100px;
}

.auth-card {
  width: 100%;
  max-width: 440px;
  padding: 40px;
  border-radius: var(--radius-lg);
  z-index: 1;
  box-shadow: var(--shadow-xl);
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.auth-header {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.auth-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px;
}

.logo-icon {
  width: 48px;
  height: 48px;
  background: var(--gradient-brand);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 800;
  color: white;
  box-shadow: 0 4px 15px rgba(153, 27, 27, 0.4);
}

.auth-logo h1 {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.04em;
  color: var(--text-bright);
}

.auth-subtitle {
  color: var(--text-secondary);
  font-size: 16px;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-group label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  color: var(--text-muted);
  transition: color var(--transition-fast);
}

.input-wrapper input {
  width: 100%;
  height: 52px;
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--radius-md);
  padding: 0 16px 0 48px;
  color: var(--text-primary);
  font-size: 15px;
  transition: all var(--transition-fast);
}

.input-wrapper input:focus {
  border-color: var(--brand-primary);
  background: rgba(2, 6, 23, 0.8);
  outline: none;
  box-shadow: 0 0 0 4px rgba(153, 27, 27, 0.1);
}

.input-wrapper input:focus + .input-icon {
  color: var(--brand-primary);
}

.forgot-password {
  align-self: flex-end;
  font-size: 13px;
  color: var(--brand-light);
  text-decoration: none;
  margin-top: 4px;
  transition: color var(--transition-fast);
}

.forgot-password:hover {
  color: var(--brand-hover);
}

.auth-error {
  background: rgba(153, 27, 27, 0.1);
  border: 1px solid rgba(153, 27, 27, 0.2);
  padding: 12px;
  border-radius: var(--radius-sm);
  color: #fca5a5;
  font-size: 14px;
  text-align: center;
}

.auth-submit-btn {
  height: 52px;
  background: var(--gradient-brand);
  border: none;
  border-radius: var(--radius-md);
  color: white;
  font-size: 16px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  transition: all var(--transition-fast);
  margin-top: 8px;
}

.auth-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  filter: brightness(1.1);
  box-shadow: 0 8px 20px rgba(153, 27, 27, 0.3);
}

.auth-submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.auth-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.auth-footer {
  text-align: center;
  padding-top: 8px;
}

.auth-footer p {
  font-size: 15px;
  color: var(--text-secondary);
}

.toggle-auth {
  background: none;
  border: none;
  color: var(--brand-light);
  font-weight: 700;
  margin-left: 8px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.toggle-auth:hover {
  background: rgba(153, 27, 27, 0.1);
  color: var(--brand-hover);
}

.auth-version {
  position: absolute;
  bottom: 24px;
  color: var(--text-muted);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.google-login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 52px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: var(--radius-md);
  color: #1e293b;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.google-login-btn:hover {
  background: #f8fafc;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.flexable-login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 52px;
  background: linear-gradient(135deg, #7c3aed 0%, #9333ea 50%, #c026d3 100%);
  border: 1px solid rgba(192, 38, 211, 0.4);
  border-radius: var(--radius-md);
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: 0 4px 18px rgba(147, 51, 234, 0.35);
  letter-spacing: 0.02em;
}

.flexable-login-btn:hover {
  filter: brightness(1.12);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(147, 51, 234, 0.55);
}

.flexable-login-btn:active {
  transform: translateY(0);
}

.logo-icon-img {
  object-fit: cover;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/Auth.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,UAAU;EACV,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,0EAA0E;EAC1E,yCAAyC;EACzC,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;AAC3C","sourcesContent":[".auth-page {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--bg-primary);\n  position: relative;\n  overflow: hidden;\n}\n\n.auth-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n}\n\n.auth-blob {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  opacity: 0.15;\n  pointer-events: none;\n}\n\n.auth-blob-1 {\n  width: 500px;\n  height: 500px;\n  background: var(--brand-primary);\n  top: -100px;\n  right: -100px;\n}\n\n.auth-blob-2 {\n  width: 400px;\n  height: 400px;\n  background: var(--info);\n  bottom: -100px;\n  left: -100px;\n}\n\n.auth-card {\n  width: 100%;\n  max-width: 440px;\n  padding: 40px;\n  border-radius: var(--radius-lg);\n  z-index: 1;\n  box-shadow: var(--shadow-xl);\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.auth-header {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.auth-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.logo-icon {\n  width: 48px;\n  height: 48px;\n  background: var(--gradient-brand);\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 800;\n  color: white;\n  box-shadow: 0 4px 15px rgba(153, 27, 27, 0.4);\n}\n\n.auth-logo h1 {\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  color: var(--text-bright);\n}\n\n.auth-subtitle {\n  color: var(--text-secondary);\n  font-size: 16px;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.input-group label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 16px;\n  color: var(--text-muted);\n  transition: color var(--transition-fast);\n}\n\n.input-wrapper input {\n  width: 100%;\n  height: 52px;\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-md);\n  padding: 0 16px 0 48px;\n  color: var(--text-primary);\n  font-size: 15px;\n  transition: all var(--transition-fast);\n}\n\n.input-wrapper input:focus {\n  border-color: var(--brand-primary);\n  background: rgba(2, 6, 23, 0.8);\n  outline: none;\n  box-shadow: 0 0 0 4px rgba(153, 27, 27, 0.1);\n}\n\n.input-wrapper input:focus + .input-icon {\n  color: var(--brand-primary);\n}\n\n.forgot-password {\n  align-self: flex-end;\n  font-size: 13px;\n  color: var(--brand-light);\n  text-decoration: none;\n  margin-top: 4px;\n  transition: color var(--transition-fast);\n}\n\n.forgot-password:hover {\n  color: var(--brand-hover);\n}\n\n.auth-error {\n  background: rgba(153, 27, 27, 0.1);\n  border: 1px solid rgba(153, 27, 27, 0.2);\n  padding: 12px;\n  border-radius: var(--radius-sm);\n  color: #fca5a5;\n  font-size: 14px;\n  text-align: center;\n}\n\n.auth-submit-btn {\n  height: 52px;\n  background: var(--gradient-brand);\n  border: none;\n  border-radius: var(--radius-md);\n  color: white;\n  font-size: 16px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  margin-top: 8px;\n}\n\n.auth-submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  filter: brightness(1.1);\n  box-shadow: 0 8px 20px rgba(153, 27, 27, 0.3);\n}\n\n.auth-submit-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.auth-submit-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.auth-footer {\n  text-align: center;\n  padding-top: 8px;\n}\n\n.auth-footer p {\n  font-size: 15px;\n  color: var(--text-secondary);\n}\n\n.toggle-auth {\n  background: none;\n  border: none;\n  color: var(--brand-light);\n  font-weight: 700;\n  margin-left: 8px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-fast);\n}\n\n.toggle-auth:hover {\n  background: rgba(153, 27, 27, 0.1);\n  color: var(--brand-hover);\n}\n\n.auth-version {\n  position: absolute;\n  bottom: 24px;\n  color: var(--text-muted);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.google-login-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  height: 52px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: var(--radius-md);\n  color: #1e293b;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.google-login-btn:hover {\n  background: #f8fafc;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.05);\n}\n\n.flexable-login-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  height: 52px;\n  background: linear-gradient(135deg, #7c3aed 0%, #9333ea 50%, #c026d3 100%);\n  border: 1px solid rgba(192, 38, 211, 0.4);\n  border-radius: var(--radius-md);\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: 0 4px 18px rgba(147, 51, 234, 0.35);\n  letter-spacing: 0.02em;\n}\n\n.flexable-login-btn:hover {\n  filter: brightness(1.12);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(147, 51, 234, 0.55);\n}\n\n.flexable-login-btn:active {\n  transform: translateY(0);\n}\n\n.logo-icon-img {\n  object-fit: cover;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
